export default {
    variants: [      
        "primary",
        "secondary",        
        "success",
        "danger",
        "warning",
        "info",        
        "light",
        "dark",
        "link",
        "no-variant"
    ],
    bubble_variants: [
        "primary",
        "secondary"
    ]
}